import { Component, Inject } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";

@Component({
    selector: 'app-checking-account-detail-with-schedules-delete',
    template: require('./checkingAccountDetailsDialogDelete.html')
})
export class CheckingAccountDetailsDeleteDialog {

    constructor(@Inject(MatDialogRef<CheckingAccountDetailsDeleteDialog>) public dialogRef: MatDialogRef<CheckingAccountDetailsDeleteDialog>) {
    }

    closeThisDialog(value: any) {
        this.dialogRef.close(value)
    }

}
